























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class LocationField extends Vue {
  @Prop() value!: any;

  options = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: true,
    disableDefaultUi: false,
  };

  center = {
    lat: -6.917463899999999,
    lng: 107.6191228,
  };

  zoom = 15;

  onPlaceChanged(place: any) {
    this.center = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
  }

  onMapClicked(event: any) {
    this.center = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };
  }

  @Watch('value', {immediate: true})
  onValueChanged(val: any) {
    this.center = val;
  }

  @Watch('center')
  onCenterChanged(val: any) {
    this.$emit('input', val);
  }
}
